import { getLogger } from '../../diagnostics/logger';
import moment from 'moment';
import { Action, ActionMeta } from '../../actions';
import {
  LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE,
  LOAD_NETWORK_BUNDLE_TOPUPS_PENDING,
  LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS,
} from '../../actions/actionTypes';
import { DropdownItem } from '../../components/ui/input/DropdownInput';
import { SimManagementError } from '../../models/Errors';
import { initialAppState } from '../../models/state/appState';
import { BundleTopupsStateCacheTimeout } from '../../models/state/simProvision/cacheTimeouts';
import { getDefaultDropdownItems } from '../../models/state/simProvision/defaults';
import { DropdownItems, DropdownItemsState } from '../../models/state/simProvision/simProvisionState';
const log = getLogger('simManagement.reducers.bundleTopupReducer');

export default function tariffReducer(
  state: DropdownItemsState = initialAppState.simProvisionState.bundleTopupSizes,
  action: any,
): DropdownItemsState {
  switch (action.type) {
    case LOAD_NETWORK_BUNDLE_TOPUPS_PENDING: {
      const typedAction = action as Action<number>;
      const { payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const bundleSize = payload;
      const bundleTopups: DropdownItems = {
        ...getDefaultDropdownItems(),
        isLoading: true,
      };

      const changedState: DropdownItemsState = {};
      changedState[bundleSize] = bundleTopups;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE: {
      const typedAction = action as ActionMeta<number, SimManagementError>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const bundleSize = payload;
      const bundleTopups: DropdownItems = {
        ...getDefaultDropdownItems(),
        error: meta,
      };

      const changedState: DropdownItemsState = {};
      changedState[bundleSize] = bundleTopups;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS: {
      const typedAction = action as ActionMeta<number, DropdownItem[]>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const bundleSize = payload;
      const tariffs = meta;
      const date = new Date();

      const bundleTopups: DropdownItems = {
        ...getDefaultDropdownItems(),
        items: [...tariffs],
        byId: Object.assign({}, ...tariffs.map((a: any) => ({
          [a.key]: a
        }))),
        expiresOn: moment().add(BundleTopupsStateCacheTimeout, 'seconds').toDate(),
      };

      const changedState: DropdownItemsState = {};
      changedState[bundleSize] = bundleTopups;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    default:
      return state;
  }
}
